// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from 'D:/software/VueProject/demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import HomeOutlined from 'D:/software/VueProject/demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/HomeOutlined';
import BugOutlined from 'D:/software/VueProject/demo/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/BugOutlined';
export default { DashboardOutlined, HomeOutlined, BugOutlined };
